import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Download20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M15.9696 7.96967L10.75 13.1893V1H9.25001V13.1894L4.03028 7.96967L2.96962 9.03033L9.99995 16.0607L17.0303 9.03033L15.9696 7.96967Z'
      fill='currentColor'
    />
    <path d='M16.5 18.25H3.50001V19.75H16.5V18.25Z' fill='currentColor' />
  </Svg>
);

Download20.displayName = 'Download20';
export default Download20;
